import { render, staticRenderFns } from "./IndividualContact2.vue?vue&type=template&id=042df948&scoped=true&"
import script from "./IndividualContact2.vue?vue&type=script&lang=js&"
export * from "./IndividualContact2.vue?vue&type=script&lang=js&"
import style0 from "./IndividualContact2.vue?vue&type=style&index=0&id=042df948&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "042df948",
  null
  
)

export default component.exports